import {inject} from 'mobx-react';
import React from 'react';
import {Route, Switch} from 'react-router-dom';
import Auth from './Auth';
import Dashboard from './Dashboard';
import NoMatch from './NoMatch';
import ProtectedRoute from './ProtectedRoute';

const App = () => (
  <Switch>
    <ProtectedRoute exact path="/" component={Dashboard} />
    <Route path="/auth" component={Auth} />
    <Route component={NoMatch} />
  </Switch>
);

export default inject('store')(App);
